import { render, staticRenderFns } from "./RgsCardItem.vue?vue&type=template&id=1470c532&"
import script from "./RgsCardItem.vue?vue&type=script&lang=ts&"
export * from "./RgsCardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports